import { Link } from "react-router-dom";
import { Logo } from "./Navbar";

const TMDB_LOGO =
  "https://www.themoviedb.org/assets/2/v4/logos/v2/blue_short-8e7b30f73a4020692ccca9c88bafe5dcb6f8a62a4c6bc55cd9ba82bb2cd95f6c.svg";

const COLS = [
  { title: "Explore", links: [["Home", "/"], ["Movies", "/movies"]] },
  { title: "Company", links: [["About Us", "/about"], ["Contact", "/contact"]] },
];

export const Footer = () => (
  <footer data-testid="footer" className="mt-16 border-t border-white/10 bg-[#070707]">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-20 md:grid-cols-12 md:px-10">
      <div className="md:col-span-5">
        <Logo />
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-neutral-400">
          A curated window into the films the world is watching right now. Discover, decide, and press play.
        </p>
      </div>
      {COLS.map((c) => (
        <div key={c.title} className="md:col-span-2">
          <p className="eyebrow text-[#D4AF37]">{c.title}</p>
          <ul className="mt-5 space-y-3">
            {c.links.map(([label, to]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`} className="text-sm text-neutral-300 transition-colors duration-300 hover:text-[#D4AF37]">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div className="md:col-span-3" data-testid="tmdb-attribution">
        <p className="eyebrow text-[#D4AF37]">Data Source</p>
        <a href="https://www.themoviedb.org/" target="_blank" rel="noopener noreferrer" className="mt-5 inline-block" data-testid="tmdb-logo-link">
          <img src={TMDB_LOGO} alt="TMDB logo" className="h-5 w-auto" />
        </a>
        <p className="mt-4 text-sm leading-relaxed text-neutral-300">
          This product uses the TMDB API but is not endorsed or certified by TMDB.
        </p>
      </div>
    </div>
    <div className="border-t border-white/5">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-neutral-500 md:flex-row md:justify-between md:px-10">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Exclusive Streams. All rights reserved.</p>
        <p>Watch Now links are affiliate links. We may earn a commission.</p>
      </div>
    </div>
  </footer>
);
